<script setup lang="ts">
import type { UIChipsProps } from './UIChips.props'

defineProps<UIChipsProps>()

const emit = defineEmits(['select'])
</script>

<template>
  <button
    :class="[
      isTimelineStyle
        ? 'text-light-6 gap-6'
        : 'text-light-7 bg-background-chips h-8 px-4 py-2',
      {
        'border-b-background-primary border-b': selected && !isTimelineStyle,
        'text-medium-6': selected && isTimelineStyle,
      },
    ]"
    @click="emit('select')"
  >
    {{ label }}
  </button>
</template>
